import _ from 'lodash';

export const getDealerAddress = (addressObj) => {
    return `${_.get(addressObj, `address`)} ${_.get(addressObj, `address1`)}, ` +
     `${_.get(addressObj, `city`)}, ${_.get(addressObj, `region`)} ${_.get(addressObj, `zip`)}`;
};

export const hasDealerRole = (customer) => {
    return _.includes(_.get(customer, `groups`, []), `DEALER`);
};

export const getLastModified = (groupData, isDate) => {
    return _.isArray(groupData) ? _.get(groupData[groupData.length - 1], isDate ? `changedOn` : `changedBy`, `-`) : `-`;
};